export const admins = [
  "xEIB1uHX2vOtHUL7h6kgjdfUbxp1",
  "kLTQ3D0nBASC8zYGmepd5Zc6ISV2",
  "1DSPu8aMYabcpNTPMEOQLl5Ei2t1",
  "ksvifBrOtCfPObH4xUMI9xPuRBC3"
];
